import gql from "graphql-tag"

const newsSource = gql`
  fragment NewsSource on NewsSource {
    id
    image
    labelId
    name
    outletId
    releaseDate
    serviceName
    text
    url
  }
`

export default newsSource
